import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  getHugggImage,
  needsCustomImage,
  getSegmentImages,
  getSegments
} from 'utilities/huggg';
import styles from './huggg.module.scss';
import { Carousel } from '@huggg/react-components';

const SegmentImageCollage = ({ segmentImages }) => {
  const displayedImages = segmentImages.slice(0, 4);
  const className = `collage-${displayedImages.length}`;
  const images = displayedImages.map((img, i) => (
    <div key={img} data-test-id="segment-image-collage" className={classnames(styles[`${className}-image-container`], styles.collageImageContainer)}>
      <img
        src={img}
        alt={`Gift ${i}`}
        className={styles.collageImage}
      />
    </div>
  ));

  return (
    <div className={classnames(styles.collage, styles[className])}>
      {images}
    </div>
  );
};

SegmentImageCollage.propTypes = {
  segmentImages: PropTypes.array
};

const SingleSegmentCarousel = (props) => (
  <Carousel
    dots={true}
    arrows={false}
    preview={false}
    isPlaying={true}
    interval={3000}
    dragEnabled={true}

  >
    {props.images.map((imageUrl, index) => (
      <div
        key={index}
        data-test-id="single-segment-carousel-image"
      >
        <img
          src={imageUrl}
          alt="preview of the product"
          className={styles.imageContainer}
        />
      </div>
    ))}
  </Carousel>
);

SingleSegmentCarousel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired
};

const HugggImage = ({ huggg, imageOverride }) => {
  const imgUrl = getHugggImage(huggg);
  const isCustom = needsCustomImage(huggg);
  const segments = getSegments(huggg);
  const segmentImages = isCustom ? getSegmentImages(huggg) : null;

  if (segments.length === 1 && segments[0].images.length > 1) {
    return (
      <SingleSegmentCarousel images={segments[0].images} />
    );
  }

  if (segmentImages && segmentImages.length > 1) {
    return <SegmentImageCollage segmentImages={segmentImages} />;
  }

  const getDisplayUrl = () => {
    if (imageOverride) return imageOverride;
    if (segmentImages && segmentImages.length === 1) return segmentImages[0];
    return imgUrl;
  };

  const displayUrl = getDisplayUrl();

  return displayUrl ? (
    <div className={classnames(styles.imageContainer)}>
      <img
        src={displayUrl}
        alt="Huggg"
        className={classnames(styles.image, 'image')}
      />
    </div>
  ) : null;
};

HugggImage.propTypes = {
  huggg: PropTypes.object.isRequired,
  imageOverride: PropTypes.string
};

export default HugggImage;
